import {
  getCustomerDrawerOptions,
  MarketAccountStatusEnum,
  type ColumnDef,
  type Customer,
  type CustomerMarketAccount,
  type InputsAndDropdownsDrawerOption,
} from '@talos/kyoko';

const CUSTOMER_ACCOUNT_ID_TOOLTIP =
  'ID that identifies this account to end customers. It will be visible in their Whitelabeled UI ("default" is assigned to system-generated accounts)';
export const CUSTOMER_ACCOUNTS_COLUMNS: ColumnDef<CustomerMarketAccount>[] = [
  {
    type: 'text',
    field: 'Status',
  },
  {
    type: 'customer',
    field: 'Counterparty',
    title: 'Customer',
  },
  { type: 'text', field: 'Name', title: 'Name' },
  { type: 'text', field: 'SourceAccountID', title: 'Customer Account ID', description: CUSTOMER_ACCOUNT_ID_TOOLTIP },
  { type: 'text', field: 'DisplayName', title: 'Display Name' },
];

export function getCustomerAccountsDrawerOptions({
  customers,
}: {
  customers: Customer[];
}): InputsAndDropdownsDrawerOption<CustomerMarketAccount>[] {
  return [
    {
      field: 'Counterparty',
      type: 'dropdown',
      title: 'Customer',
      getIsRequired: () => true,
      getDropdownOptions: () => getCustomerDrawerOptions(customers),
      disabledWhenEditing: true,
    },
    {
      field: 'SourceAccountID',
      title: 'Customer Account ID',
      type: 'input',
      disabledWhenEditing: true,
      tooltip: CUSTOMER_ACCOUNT_ID_TOOLTIP,
    },
    {
      type: 'dropdown',
      field: 'Status',
      getDropdownOptions: () => [
        { value: MarketAccountStatusEnum.Active, label: 'Active' },
        { value: MarketAccountStatusEnum.Inactive, label: 'Inactive' },
        { value: MarketAccountStatusEnum.Disabled, label: 'Disabled' },
      ],
    },
    {
      type: 'input',
      field: 'DisplayName',
    },
  ];
}
